<template>
  <transition name="slide">
    <div class="sidenav-container" :class="{'opened': sidenavVisible}">
      <div class="closebtn link" @click="close()">
        <font-awesome-icon :icon="['fal', 'times']" size="2x" fixed-width />
      </div>
      <div class="element-container">
        <div class="nav-element link" v-for="element in elements" :key="element.name" @click="clicked(element)"
        :class="{'current': $route.name === element.currentOn}">
          <div>
            <span class="icon">
              <font-awesome-icon :icon="element.icon" fixed-width />
            </span>
            <span class="text">
              {{ element.text }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SideNav',
  computed: {
    ...mapState(['location', 'locations', 'sidenavVisible']),
    mobile() {
      return window.innerWidth < 500
    },
    elements() {
      if (!this.location) return null
      return [
        {
          name: 'landing',
          currentOn: 'landing',
          link: '/',
          text: 'Startseite',
          icon: ['fal', 'home'],
        },
        // {
        //   name: 'location',
        //   currentOn: 'location',
        //   link: 'location',
        //   text: this.location.name,
        //   icon: ['fal', 'map-marker'],
        // },
        {
          name: 'carte',
          currentOn: 'carte',
          link: 'carte',
          text: 'Speisekarte',
          icon: ['fal', 'utensils'],
        },
        {
          name: 'openings',
          highlight: 'openinghours',
          text: 'Öffnungszeiten',
          icon: ['fal', 'clock'],
        },
        {
          name: 'reservations',
          highlight: 'reservations',
          text: 'Reservierungen',
          icon: ['fal', 'concierge-bell'],
        },
      ]
    },
  },
  components: {},
  data: function () {
    return {
      compress: false,
      yOffset: 0,
    }
  },
  watch: {
    $route(to, from) {
      // this.close();
    },
  },
  mounted() {

  },
  methods: {
    close() {
      this.$store.dispatch('closeSidenav')
    },
    autoClose() {
      if (this.mobile) this.$store.dispatch('closeSidenav')
    },
    clicked(element) {
      if (element.onClick) {
        element.onClick()
      }
      if (element.highlight) {
        var target = document.getElementById(element.highlight)
        target.classList.add('highlight')
        setTimeout(function () {
          target.classList.add('highlight-trans')
          target.classList.remove('highlight')
          setTimeout(function () {
            target.classList.remove('highlight-trans')
          }, 2000)
        }, 800)
        target.scrollIntoView(true)
      }
      if (element.link) {
        if (this.$route.name !== element.currentOn) {
          this.$router.push(element.link)
        }
        window.scrollTo(0, 0)
      }
      this.autoClose()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/style/settings.scss";

.sidenav-container {
  max-width: 85vw;
  display: none;
  position: relative;

  &.opened {
    display: block;
  }

  @media (min-width: $media-m) {
    position: sticky;
    top: $navbar-offset;
    // top: 0;
  }

  @media (min-width: $media-l) {
    display: block;
  }

  @media (max-width: $media-s) {
    height: 100%;
    position: fixed;
    z-index: 6000;
    background-color: rgba(0,0,0,.99);
    // top: $navbar-offset;
    top: 0;
    left: 0;
    overflow-x: hidden;
  }

  .element-container {
    @media (min-width: $media-m) {
      border-right: 1px solid rgba(255,255,255,.2);
    }
    .nav-element {
      text-align: left;
      padding: 1em 1.5em;
      white-space: nowrap;
      &.current {
        font-weight: 400;
        color: $highlight-color-dark;
      }
      .icon {
        margin-right: .7em;
      }
    }
  }

  .closebtn {
    display: none;
    @media (max-width: $media-s) {
      display: block;
    }
    padding: 1em;
    text-align: right;
  }

  .slide-enter-active, .slide-leave-active {
    overflow: hidden;
    transition: width 10s;
  }
  .slide, .slide-leave-to {
    width: 0;
    transition: width 10s;
  }
}

</style>
